export default __webpack_public_path__ + "static/media/GothamRnd-Medium.10d88929.otf";